import DeleteProduct from '../../components/delete-product'

const init = () => {
  DeleteProduct()
}

export default init
